import { f7 } from 'framework7-react';
import { useCallback, useState } from 'react';
import {
  RepairItemSelectInfoType,
  RepairRequestIDInfoType,
} from '../../../types/bodyAndPaint';
import { usePostRepairRequest } from './hook/api/usePostRepairRequest';
import { useRepairRequestData } from './hook/useRepairRequestData';
import { useStorageItem } from './hook/useStorageItem';
import { RepairItemRequest } from './repairItemRequest/repairItemRequest';
import { RepairRequestDialogCard } from './repairItemRequest/repairRequestDialogCard';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { DialogComponent } from './util/dialogFrame';
import { paths } from '@/config/paths';

export const RepairItemRequestPage = () => {
  const { stored } = useStorageItem<{
    ids: RepairRequestIDInfoType;
    repairSelectList: RepairItemSelectInfoType;
    repairRequestItem: {
      status: number;
      carName: string;
      category: string;
      factoryName: string;
      totalAmount: number;
    };
  }>({ key: 'repairRequestConfirmItem' });

  const { isEstimating, repairRequestData, repairRequestParam } =
    useRepairRequestData({
      data: stored,
    });
  const { postRequest: requestRepair } = usePostRepairRequest({
    info: repairRequestParam,
  });

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsRepairItemSelect);
  };
  const handleClickCorrectButton = useCallback(() => {
    f7.views.main.router.navigate(paths.bpsRepairItemSelect);
  }, []);
  const handleClickRequestButton = useCallback(() => {
    requestRepair().then(() => {
      setOpenConfirmDialog(true);
    });
  }, [requestRepair]);
  const handleClickCloseDialog = useCallback(() => {
    f7.views.main.router.navigate(paths.maintenance);
  }, []);

  return (
    <PageTemplateComponent
      pageName={'repairItemRequest'}
      title={'依頼確認'}
      onBack={handleClickBack}
    >
      <RepairItemRequest
        info={repairRequestData}
        onCorrect={handleClickCorrectButton}
        onRequest={handleClickRequestButton}
        isEstimating={isEstimating}
      />
      <DialogComponent open={openConfirmDialog}>
        <RepairRequestDialogCard onClose={handleClickCloseDialog} />
      </DialogComponent>
    </PageTemplateComponent>
  );
};
